import { useEffect, useRef, useState } from "react";

export default function Message({
  type = "success",
  message,
  duration = 3000,
  onClear,
}) {
  const [visible, setVisible] = useState(false);

  const onClearRef = useRef(onClear);
  useEffect(() => {
    onClearRef.current = onClear;
  }, [onClear]);

  useEffect(() => {
    if (!message) {
      setVisible(false);
      return;
    }

    // Reset markers and restart animation
    setVisible(false);

    const showTimer = setTimeout(() => {
      setVisible(true);
    }, 10);

    const hideTimer = setTimeout(() => {
      setVisible(false);
    }, duration);

    const clearTimer = setTimeout(() => {
      onClearRef.current?.();
    }, duration + 400);

    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
      clearTimeout(clearTimer);
    };
  }, [message, duration]);

  if (!message) return null;

  return (
    <div
      className={`message ${type} ${visible ? "show" : "hide"}`}
      style={{ '--duration': `${duration}ms` }}
    >
      <span className="message-text">{message}</span>

      <button
        className="message-close"
        onClick={() => {
          setVisible(false);
          setTimeout(() => {
            onClear?.();
          }, 400);
        }}
      >
        <span className="material-symbols-outlined" style={{ fontSize: '20px' }}>close</span>
      </button>

      <div className="message-progress"></div>
    </div>
  );
}
